import React, { Fragment, useEffect, useState, useContext } from "react";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Route, Redirect } from "react-router";
import './gs.css';
import './gs_add.css';
import { Layout } from './Layout';
import { dateFormat, getDataById, getDataByUniq, handleUrl } from './utils';
import { Projects } from './Projects';
import { HoverScrubber } from './Scrubber';
import { Playlist } from './Playlist';
import { ContentList } from './ContentList';
import { PlaylistTop } from './PlaylistTop';
import { ScrubberLine } from "./ScrubberLine";
import { Login } from './Login';
import { VersionToggle } from "./withVersion";
import Pop from './Pop';
import { MetadataThreadsList } from "./MetadataThreadsList";


export function Routes(props) {

  const context = useContext(Context);

  return (
    <>
      <VersionToggle />
      {/* <Elements stripe={stripePromise}> */}
      <Router
      // history={hist}
      >
        <Switch>


          <Route
            path="/login"
            render={({ match }) => {
              return (
                <Login />
              )
            }}
          />

          <Route
            path="/createaccount"
            render={({ match }) => {
              return (
                <Login create />
              )
            }}
          />

          <Route
            path="/forgotpassword"
            render={({ match }) => {
              return (
                <Login forgot />
              )
            }}
          />



          <Route
            path="/scrubber"
            render={({ match }) => {
              return (
                <div style={{ padding: 20 }}>
                  <HoverScrubber width={240} height={172} sprite='https://res.cloudinary.com/generalsymbol/image/upload/v1639770770/samples/out_vkcckn.jpg' />
                </div>
              )
            }}
          />
          <Route
            path="/scrubberline"
            render={({ match }) => {
              return (
                <div style={{ padding: 20 }}>
                  <ScrubberLine />
                </div>
              )
            }}
          />

          <Route
            path="/videoscrubber"
            render={({ match }) => {
              return (
                <div style={{ padding: 20 }}>
                  <HoverScrubber width={240} height={172} sprite='https://res.cloudinary.com/generalsymbol/image/upload/v1639770770/samples/out_vkcckn.jpg' />
                </div>
              )
            }}
          />






          <Route
            exact
            path="/clear"
            render={({ history }) => {
              localStorage.clear();
              history.push("");
              return null;
            }}
          />


          <Route
            exact path="/calendar/today"
            render={(props) => {
              return (
                <>
                  {/* <Redirect to={`/calendar/${dateFormat}`} /> */}
                  <Redirect to={`/`} />
                </>
              )
            }}
          />

          <Route
            path="/calendar/:year?/:month?/:day?"
            render={(props) => {
              return (
                <Layout />
              )
            }}
          />



          <Route
            path="/:space/smartcaptures/:videoId?/:action?"
            render={({ match, history }) => {
              return (
                <>
                  <Layout videoId={match.params['videoId']}>
                    <PlaylistTop
                      // img
                      title='Smart captures'
                      // color
                      emoji='🎦'
                    // size
                    // handleMenu
                    />
                    <ContentList
                      userId={getDataByUniq(context, 'spaces', match.params['space'], 'type') === 'personal' ? context.user['id'] : null}
                    />
                  </Layout>
                  {match.params['action'] === 'create' && <Pop
                    title={'Metadata threads'}
                    closeHandler={() => {
                      handleUrl(history, match, match.params['videoId'], '')
                    }}
                  >
                    <MetadataThreadsList
                      videoId={match.params['videoId']}
                    />
                  </Pop>}
                </>
              )
            }}
          />


          <Route
            path="/:space/list/:playlistId?/:videoId?/:action?"
            render={({ match, history }) => {
              return (<>
                <Layout videoId={match.params['videoId']}>
                  <Playlist
                    playlistId={context.handles.getPlaylistIdFromName(match.params['playlistId'])}
                  />
                </Layout>
                {match.params['action'] === 'create' && <Pop
                  title={'Metadata threads'}
                  closeHandler={() => handleUrl(history, match, match.params['videoId'], '')}
                >
                  <MetadataThreadsList
                    videoId={match.params['videoId']}
                  />
                </Pop>}
              </>
              )
            }}
          />

          <Route
            path=":space/list/:playlistId?"
            render={({ match }) => {
              return (
                <Layout>
                  <Playlist playlistId={context.handles.getPlaylistIdFromName(match.params['playlistId'])} />
                </Layout>
              )
            }}
          />


          <Route
            path=":space/projects"
            render={({ match }) => {
              return (
                <Layout>
                  <Projects />
                </Layout>
              )
            }}
          />

          <Route
            path=":space/settings"
            render={({ match }) => {
              return (
                <Layout>
                  <Projects />
                </Layout>
              )
            }}
          />



          <Route
            exact path="/"
            render={(props) => {
              return (
                <>
                  <Redirect to="personal/smartcaptures" />
                </>
              )
            }}
          />
        </Switch>
      </Router>

      {/* <Checkout/> */}
      {/* </Elements> */}
    </>
  );
}
